var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-body", attrs: { id: "direct-delivery" } },
    [
      _c("p", { staticClass: "text-size-20" }, [
        _vm._v(
          "セラー様が梱包、発送を行い倉庫へ納品する場合の納品プランを作成いただけます"
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mr-t-20", staticStyle: { "min-width": "1500px" } },
        [
          _c("div", { staticClass: "flexbox gap-15" }, [
            _c("svg", { attrs: { width: "50", height: "50" } }, [
              _c("circle", {
                attrs: {
                  cx: "25",
                  cy: "25",
                  r: "20",
                  stroke: "#008cc6",
                  "stroke-width": "3",
                  fill: "#008cc6"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  attrs: {
                    x: "50%",
                    y: "50%",
                    "text-anchor": "middle",
                    "dominant-baseline": "central",
                    "font-size": "20",
                    fill: "#fff"
                  }
                },
                [_vm._v("1")]
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "font-bold text-size-16 text-primary" }, [
              _vm._v("基本情報入力")
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mr-t-10 bg-white mr-l-30",
              staticStyle: {
                border: "1px solid #ccc",
                "margin-left": "30px",
                padding: "10px"
              }
            },
            [
              _c("div", { staticClass: "box-delivery-name m-b-md" }, [
                _c("div", { staticClass: "row" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-10 col-lg-7" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.deliveryName,
                          expression: "deliveryName",
                          modifiers: { trim: true }
                        }
                      ],
                      class: [
                        "form-control",
                        _vm.deliveryName ? "" : "bg-no-input"
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.deliveryName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.deliveryName = $event.target.value.trim()
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "※セールモンスターのみが使用する項目です。セラー様が管理しやすい名称をご入力ください。"
                      )
                    ]),
                    _vm._v(" "),
                    _vm.validateErrors.deliveryName.length
                      ? _c("div", { staticClass: "text-red" }, [
                          _c("b", [
                            _vm._v(_vm._s(_vm.validateErrors.deliveryName[0]))
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "box-delivery-date m-b-md" }, [
                _c("div", { staticClass: "row" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-10 col-lg-6" },
                    [
                      _c("date-picker", {
                        ref: "datepickerStart",
                        attrs: {
                          placeholder: "",
                          format: "YYYY/MM/DD",
                          "input-attr": { id: "delivery-date" },
                          lang: _vm.lang,
                          "not-before": new Date(),
                          "input-class": [
                            "mx-input",
                            _vm.deliveryDate ? "" : "bg-no-input"
                          ]
                        },
                        model: {
                          value: _vm.deliveryDate,
                          callback: function($$v) {
                            _vm.deliveryDate = $$v
                          },
                          expression: "deliveryDate"
                        }
                      }),
                      _vm._v(" "),
                      _vm.validateErrors.deliveryDate.length
                        ? _c("div", { staticClass: "text-red" }, [
                            _c("b", [
                              _vm._v(_vm._s(_vm.validateErrors.deliveryDate[0]))
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "box-origin-info-default m-b-sm" }, [
                _c("div", { staticClass: "row" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-9 col-lg-10" }, [
                    _vm.deliveryInfo
                      ? _c("div", { staticClass: "delivery-info-default" }, [
                          _c("div", [_vm._v(_vm._s(_vm.deliveryInfo.name))]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.deliveryInfo.postalCode) +
                                "     " +
                                _vm._s(_vm.deliveryInfo.address) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(_vm.deliveryInfo.phoneNo))])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "text--underline",
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.openModalDeliveryInfo()
                          }
                        }
                      },
                      [_vm._v("登録・変更はこちら")]
                    ),
                    _vm._v(" "),
                    _vm.validateErrors.deliveryInfo.length
                      ? _c("div", { staticClass: "text-red" }, [
                          _c("b", [
                            _vm._v(_vm._s(_vm.validateErrors.deliveryInfo[0]))
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mr-t-20", staticStyle: { "min-width": "1500px" } },
        [
          _c("div", { staticClass: "flexbox gap-15" }, [
            _c("svg", { attrs: { width: "50", height: "50" } }, [
              _c("circle", {
                attrs: {
                  cx: "25",
                  cy: "25",
                  r: "20",
                  stroke: "#008cc6",
                  "stroke-width": "3",
                  fill: "#008cc6"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  attrs: {
                    x: "50%",
                    y: "50%",
                    "text-anchor": "middle",
                    "dominant-baseline": "central",
                    "font-size": "20",
                    fill: "#fff"
                  }
                },
                [_vm._v("2")]
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "font-bold text-size-16 text-primary" }, [
              _vm._v("商品情報入力")
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mr-t-10 bg-white mr-l-30",
              staticStyle: {
                border: "1px solid #ccc",
                "margin-left": "30px",
                padding: "10px"
              },
              attrs: { id: "product-input" }
            },
            [
              _c("fixed-header", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowFixedHeader,
                    expression: "isShowFixedHeader"
                  }
                ],
                attrs: { textBtnRegister: "納品依頼" },
                on: {
                  handleClickAdd: function($event) {
                    _vm.openModalDeliveryProductAdd()
                  },
                  handleClickRegister: function($event) {
                    _vm.submitValidate()
                  }
                }
              }),
              _vm._v(" "),
              _c("p", {}, [
                _vm._v("商品選択より、納品する商品を選択してください。")
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary check-maintenance",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.openModalDeliveryProductAdd()
                    }
                  }
                },
                [_vm._v("商品選択")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-warning check-maintenance",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.openModalUpload()
                    }
                  }
                },
                [_vm._v("CSVアップロード")]
              ),
              _vm._v(" "),
              _vm.selectedProducts.length
                ? _c("div", { staticClass: "table-selected-products" }, [
                    _c("table", [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.selectedProducts, function(
                          selectedProduct,
                          index
                        ) {
                          return _c("tr", { key: index }, [
                            _c("td", { staticClass: "text-center" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "box-selected-product-image w-40"
                                },
                                [
                                  _c("img", {
                                    staticClass:
                                      "selected-product-image img-responsive",
                                    attrs: {
                                      src: selectedProduct.image,
                                      alt: ""
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class:
                                    "box-delivery-judgment-status " +
                                    _vm.getJudgmentStatusClass(
                                      selectedProduct.status_str
                                    )
                                },
                                [_vm._v(_vm._s(selectedProduct.status_str))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", { staticClass: "m-b-xs" }, [
                                _vm._v(_vm._s(selectedProduct.itemName))
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("b", [_vm._v("ASIN：")]),
                                _vm._v(_vm._s(selectedProduct.asin))
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "td-vertical-top",
                                attrs: { align: "right" }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: selectedProduct.quantity,
                                      expression: "selectedProduct.quantity"
                                    }
                                  ],
                                  staticClass:
                                    "form-control expected-delivery-number text-right mr-t-30 w-100",
                                  class: parseInt(selectedProduct.quantity)
                                    ? ""
                                    : "bg-no-input",
                                  attrs: {
                                    type: "text",
                                    disabled: selectedProduct.disableEdit
                                  },
                                  domProps: { value: selectedProduct.quantity },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          selectedProduct,
                                          "quantity",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        selectedProduct.quantity = _vm.handleInputQuantity(
                                          selectedProduct.quantity
                                        )
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _vm.validateErrors.quantity[
                                  selectedProduct.asin
                                ] &&
                                _vm.validateErrors.quantity[
                                  selectedProduct.asin
                                ].length
                                  ? _c("div", { staticClass: "text-red" }, [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.validateErrors.quantity[
                                              selectedProduct.asin
                                            ][0]
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", { attrs: { colspan: "3" } }, [
                              _c("div", { staticClass: "box-colspan gap-20" }, [
                                _c(
                                  "div",
                                  { staticClass: "w-230" },
                                  [
                                    _c("fnsku-kbn-item", {
                                      key: "fnskuKbn-" + selectedProduct.asin,
                                      staticClass: "mr-t-30",
                                      attrs: {
                                        product: selectedProduct,
                                        isChangeSku: true,
                                        isDisableEdit:
                                          selectedProduct.disableEdit
                                      }
                                    }),
                                    _vm._v(" "),
                                    !_vm.validateErrors.fnsku[
                                      selectedProduct.asin
                                    ] || selectedProduct.sku
                                      ? _c(
                                          "div",
                                          { staticClass: "text-gray" },
                                          [
                                            _vm._v(
                                              "SKU：" +
                                                _vm._s(selectedProduct.sku)
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.validateErrors.fnsku[
                                      selectedProduct.asin
                                    ] && !selectedProduct.fnsku
                                      ? _c("div", { staticClass: "text-red" }, [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.validateErrors.fnsku[
                                                  selectedProduct.asin
                                                ]
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "box-product-label-attach-kbn w-200"
                                  },
                                  [
                                    _c("div", { staticClass: "h-30" }),
                                    _vm._v(" "),
                                    _c("goods-label-attach-kbn-item", {
                                      attrs: {
                                        product: selectedProduct,
                                        isDisableEdit:
                                          selectedProduct.disableEdit
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "box-due-date-manage w-200" },
                                  [
                                    _c("due-date-management-item", {
                                      key:
                                        "due-date-manage-" +
                                        selectedProduct.asin,
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        product: selectedProduct,
                                        isDisableEdit:
                                          selectedProduct.disableEdit
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.validateErrors.dueDateManagement[
                                      selectedProduct.asin
                                    ] &&
                                    _vm.validateErrors.dueDateManagement[
                                      selectedProduct.asin
                                    ].length
                                      ? _c("div", { staticClass: "text-red" }, [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.validateErrors
                                                  .dueDateManagement[
                                                  selectedProduct.asin
                                                ][0]
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "m-t-xs availability-date text-right",
                                  class: [
                                    _vm.getAvailabilityDate(selectedProduct)
                                      ? ""
                                      : "availability-date-visibility"
                                  ]
                                },
                                [
                                  _vm._v(
                                    "\n                  出荷可能期限日：" +
                                      _vm._s(
                                        _vm.getAvailabilityDate(selectedProduct)
                                      ) +
                                      "までの注文に対して出荷することができます。\n                "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "td-vertical-top text-center" },
                              [
                                _c("div", { staticClass: "h-30" }),
                                _vm._v(" "),
                                !selectedProduct.disableDelete
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-delete-selected-product check-maintenance",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.deleteSelectedProduct(
                                              selectedProduct
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("削除")]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-center m-b-md m-t-md" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary custom-btn-delivery check-maintenance",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.submitValidate($event)
                            }
                          }
                        },
                        [
                          _vm._v("\n            納品依頼\n            "),
                          _c("i", {
                            staticClass: "fa fa-check fa-lg mr-l-5",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    ])
                  ])
                : _c("div", { staticClass: "empty-products text-center" }, [
                    _vm._m(4)
                  ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.openDeliveryInfoModal
        ? _c("delivery-info-modal", {
            ref: "deliveryInfoModal",
            attrs: { type: "Across" },
            on: {
              close: _vm.closeModalDeliveryInfo,
              openModalRegisterDeliveryInfo: _vm.openModalRegisterDeliveryInfo,
              setDefaultInfoSuccess: _vm.setDeliverySellerInfo
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openRegisterDeliveryInfoModal
        ? _c("register-delivery-info-modal", {
            ref: "registerDeliveryInfoModal",
            attrs: { type: "Across" },
            on: {
              close: _vm.closeModalRegisterDeliveryInfo,
              updatedDeliveryInfo: _vm.updatedDeliveryInfo
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openDeliveryProductAddModal
        ? _c("delivery-product-add", {
            ref: "deliveryProductAddModal",
            attrs: { deliverySelectedProducts: _vm.selectedProducts },
            on: {
              close: _vm.closeModalDeliveryProductAdd,
              handleSelectedProduct: _vm.handleSelectedProduct,
              handleSelectedProducts: _vm.handleSelectedProducts
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showGetLatestProductModal
        ? _c("modal-alert-get-latest-product", {
            attrs: {
              message: _vm.getLatestProductNotiMessage,
              customBodyClass: "text-center"
            },
            on: {
              close: _vm.closeGetLatestProductModal,
              confirm: _vm.confirmGetLatestProductModal
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showGetLatestProductCompletedModal
        ? _c("modal-alert", {
            attrs: {
              message: _vm.getLatestProductCompletedMessage,
              customBodyClass: "text-center"
            },
            on: { close: _vm.closeGetLatestProductCompletedModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openAlertValidateFailsModal
        ? _c("modal-alert", {
            attrs: { message: _vm.alertValidateFailsMessage, customHide: true },
            on: { close: _vm.closeModalAlertValidateFails }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openDeliveryProductsAddConfirmModal
        ? _c("modal-confirm", {
            attrs: { message: _vm.deliveryProductsAddConfirmMessage },
            on: {
              confirm: _vm.deliveryProductsAdd,
              close: _vm.closeModalConfirmDeliveryProductsAdd
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openAlertDeliveryProductsAddedModal
        ? _c("modal-alert", {
            attrs: {
              message: _vm.alertDeliveryProductsAddedMessage,
              customHide: true,
              modalWidth: 550
            },
            on: { close: _vm.closeModalAlertProductsAdded }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowUpgradePlanModal
        ? _c("upgrade-plan-modal", { on: { close: _vm.closeUpgradePlanModal } })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowUploadModal
        ? _c("upload-csv-modal", {
            attrs: {
              header: _vm.uploadCsvHeader,
              uploadUrl:
                "Warehouse/across/delivery/direct/product-available/upload"
            },
            on: {
              handleDownloadTemplate: _vm.handleDownloadTemplate,
              handleUploadSuccess: _vm.handleUploadSuccess,
              close: _vm.closeUploadModal
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openUploadedModal
        ? _c("modal-alert", {
            attrs: {
              message: _vm.uploadedMessage,
              customHide: true,
              modalWidth: 550
            },
            on: { close: _vm.closeUploadedModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2 col-lg-1 w-150" }, [
      _c("div", { staticClass: "delivery-name" }, [
        _c("strong", [_vm._v("納品名")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2 col-lg-1 w-150" }, [
      _c("div", { staticClass: "delivery-date" }, [
        _c("strong", [_vm._v("納品予定日")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2 col-lg-1 w-150" }, [
      _c("div", { staticClass: "m-b-sm" }, [
        _c("strong", [_vm._v("発送元情報")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-center w-150" }, [
          _vm._v("納品する商品")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "min-width": "400px" } }),
        _vm._v(" "),
        _c("th", { staticClass: "text-right w-180" }, [_vm._v("納品予定数")]),
        _vm._v(" "),
        _c("th", { staticClass: "w-250" }, [_vm._v("商品ラベル")]),
        _vm._v(" "),
        _c("th", { staticClass: "w-220" }, [_vm._v("商品ラベル貼付")]),
        _vm._v(" "),
        _c("th", { staticClass: "w-220" }, [_vm._v("有効期限")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "m-b-xl text-center" }, [
      _c("strong", [_vm._v("商品選択より、納品する商品を選択してください。")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1044a96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1044a96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAcross/EditDirectDelivery.vue
// module id = null
// module chunks = 